import axios from 'axios';
import React from 'react'

const LoadHospital = () => {

    const [data, setData] = React.useState(null);
    const getData = async () => {

        axios({
            method: 'get',
            url: `https://script.google.com/macros/s/AKfycbwAMX25yxw_aksB3VkTlN_pbn4_oj0WD861BZtnz810kMql9IyXieflQ36Ofm58CPjnoA/exec?id=1`,
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((res) => {

                if (res.data && res.data.results) {
                    setData(res.data.results.filter(v => v.region));
                    console.log("Load Data Hospital Success")
                }

            })
            .catch((error) => {

                console.error('Error fetching data:', error.message);

            })

    }
    React.useEffect(() => {
        if (data === null) {
            getData()
        };
    }, [data]);

    return data

}

export default LoadHospital
